import type { OrderStatus } from '../types';

// Map of status transitions: current -> next
const STATUS_TRANSITIONS: Record<OrderStatus, OrderStatus | null> = {
  pending: 'paid',
  paid: 'preparing',
  preparing: 'delivering',
  delivering: 'completed',
  completed: null,
  cancelled: null,
};

// Statuses that can be cancelled (all except completed and already cancelled)
const CANCELLABLE_STATUSES: OrderStatus[] = ['pending', 'paid', 'preparing', 'delivering'];

export const getNextStatus = (currentStatus: OrderStatus): OrderStatus | null => {
  return STATUS_TRANSITIONS[currentStatus];
};

export const canCancelOrder = (currentStatus: OrderStatus): boolean => {
  return CANCELLABLE_STATUSES.includes(currentStatus);
};

export const getNextStatusLabel = (currentStatus: OrderStatus): string => {
  const nextStatus = getNextStatus(currentStatus);
  if (!nextStatus) return '';

  const labels: Record<OrderStatus, string> = {
    pending: 'Ожидает оплаты',
    paid: 'Оплачен',
    preparing: 'Готовится',
    delivering: 'Доставляется',
    completed: 'Завершен',
    cancelled: 'Отменен',
  };

  return labels[nextStatus];
};

export const getStatusLabel = (status: OrderStatus): string => {
  const labels: Record<OrderStatus, string> = {
    pending: 'Ожидает оплаты',
    paid: 'Оплачен',
    preparing: 'Готовится',
    delivering: 'Доставляется',
    completed: 'Завершен',
    cancelled: 'Отменен',
  };

  return labels[status];
};
